import axios from 'axios';
import { axiosConfig, ThrowErrorMsg } from '../util';

const basePathV1 = `${process.env.REACT_APP_API_URL}/v1`;

export const convertScrappedPromoToPost = (id, postType, promoType, version) => async (dispatch) => {
  try {
    const res = await axios.post(`${basePathV1}/scrappedPromo/${id}/convertToPost`, { type: postType, promoType, version }, axiosConfig);
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const getScrappedPromoById = (id) => async (dispatch) => {
  try {
    const api = `${basePathV1}/scrappedPromo/${id}`;
    const res = await axios.get(api, axiosConfig);
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const getScrappedPromos = (payload) => async () => {
  try {
    const api = `${basePathV1}/scrappedPromos`;
    const res = await axios.get(api, { params: payload }, axiosConfig);
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updateScrappedPromo = (id, data) => async (dispatch) => {
  try {
    const res = await axios.put(`${basePathV1}/scrappedPromo/${id}`, data, axiosConfig);
    return res.data;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};
